import gql from 'graphql-tag';

export default gql`
  mutation UpdatePacelOrderPackageSize($trackingNumber: String, $packageSize: String) {
    updatePacelOrderPackageSize(trackingNumber: $trackingNumber, packageSize: $packageSize) {
      linkDownLoad
    }
  }
`;
